import { isBrowser } from '@publicss/utils';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// PN: Dropping all this in here straight from @publicss/components, hence the mess.
//     Some of these hooks/components probably don't need to exist.

export function Page404({ pageContext }) {
  const { redirects, langs } = pageContext;
  const homePath = getHomeRedirect(redirects, langs);
  useClientRedirects(redirects, langs);
  return <Block404 homePath={homePath} />;
}

function useBodyClassName(className: string) {
  useEffect(() => {
    document.body.classList.add(className);
    return () => document.body.classList.remove(className);
  }, [className]);
}

const Section = styled.section`
  .container {
    height: 100vh;
    align-items: center;
    & > div {
      width: 100%;
    }
  }
  h1 {
    font-size: 158px;
  }
  .countdown {
    a {
      text-decoration: underline;
    }
  }
`;

function Block404({ homePath }) {
  useBodyClassName('fourohfour');
  const seconds = homePath ? useSecondsRedirect(5, homePath) : undefined;

  return (
    <Section id="block-404">
      <div className="container flex text-center">
        <div>
          <h1 className="color--grey-5">404</h1>
          <p>Page not found!</p>
          {homePath && (
            <p className="countdown">
              You'll go back to the homepage in {seconds} seconds (or{' '}
              <a href={homePath}>click here</a>).
            </p>
          )}
        </div>
      </div>
    </Section>
  );
}

interface Redirect {
  to: string;
  from: string;
}

function getCurrentPath() {
  return isBrowser() ? location?.pathname || '/' : '';
}

function getNavLang(langs?: string[]) {
  return isBrowser() && langs
    ? langs.find((lang) => location.href.includes(lang)) || langs[0]
    : '';
}

function getRedirect(redirects, path = getCurrentPath()) {
  if (!path) return;

  const findRedirect = ({ from }) => {
    if (from) return from.toLowerCase() === path.toLowerCase();
    return;
  };
  const toPath = redirects?.find(findRedirect)?.to;
  return toPath;
}

function getHomeRedirect(redirects: Redirect[], langs: string[]) {
  const lang = getNavLang(langs);
  const toPath = getRedirect(redirects, '/');
  if (!toPath) return '/';
  if (lang) return `/${lang}/`;
  return toPath;
}

function useClientRedirects(redirects: Redirect[], langs: string[]) {
  const path = getCurrentPath();

  useEffect(() => {
    const toPath = ['/', '/:lang/'].includes(path)
      ? getHomeRedirect(redirects, langs)
      : getRedirect(redirects, path);

    if (toPath) location.replace(toPath);
  }, [redirects, path]);
}

function useSecondsRedirect(timer: number, toPath = '/') {
  const [seconds, setSeconds] = useState(timer);

  useEffect(() => {
    const timerId = setTimeout(() => setSeconds(seconds - 1), 1000);

    return () => clearTimeout(timerId);
  }, [seconds]);

  // Redirect
  if (seconds < 1) document.location.assign(toPath);
  return seconds;
}
